import { useSplTokenAmountChange } from '@/hooks/api/useSplTokenAmountChange';
import OrderHolding from './components/OrderHolding';
import TokenData from './components/TokenData';
import TradeHandler from './components/TradeHandler';
import { useInitTokenInfo } from './hook/useInitTokenInfo';
import { useRealPriceChg } from './hook/useRealPriceChg';
import { useWsTokenKline } from './hook/usWsTokenKline';
import { SmartWebSocketProvider } from './wsContext';

export default () => {
  useInitTokenInfo();
  useWsTokenKline();
  useSplTokenAmountChange();
  useRealPriceChg();

  return (
    <div className="px-[16px] mb-[70px] mt-[12px]">
      <SmartWebSocketProvider>
        <TokenData />
        <TradeHandler />
        <OrderHolding />
      </SmartWebSocketProvider>
    </div>
  );
};
